import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 8",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.5 0.5L6.64645 6.6464C6.84171 6.8417 7.15829 6.8417 7.35355 6.6464L13.5 0.5",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronDown;
